<template>
  <div v-show="apptemp">
    <TransitionRoot appear :show="showModal" as="template">
      <Dialog as="div" @close="closeModal">
        <div class="fixed inset-0 z-30 overflow-y-auto">
          <div class="min-h-screen text-center flex">
            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0"
              enter-to="opacity-10"
              leave="duration-200 ease-in"
              leave-from="opacity-10"
              leave-to="opacity-0"
            >
              <DialogOverlay class="fixed inset-0 bg-black opacity-30" />
            </TransitionChild>

            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-50"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-50"
            >
              <div
                class="inline-block h-full w-full my-10 pb-10 mx-3 md:w-1/3 md:mx-auto max-w-screen-sm m-auto overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded"
                style="min-width: 350px"
              >
                <div class="flex flex-row">
                  <div class="flex-1"></div>
                  <div class="flex-4 pr-2 pt-2 cursor-pointer" @click="closeModal">
                    <XIcon class="text-brand-dark-gray w-7 h-7" ref="close" />
                  </div>
                </div>

                <div class="pb-5 px-5 md:px-8">
                  <h2 class="text-xl text-brand-black">
                    QR Code for <span class="text-brand-green">/{{ apptemp.slug }}</span>
                  </h2>
                </div>

                <div class="flex items-center justify-center py-10">
                  <canvas id="qr-canvas"></canvas>
                </div>

                <div class="flex items-center justify-center py-3">
                  <div class="flex items-center md:w-1/2 px-2">
                    <PrimaryButton
                      @click="downloadImage()"
                      :is-loading="downloading"
                      :disabled="downloading"
                      >Download as an image
                    </PrimaryButton>
                  </div>
                </div>
              </div>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>
<script>
import { TransitionRoot, TransitionChild, Dialog, DialogOverlay } from "@headlessui/vue"

import { XIcon } from "@heroicons/vue/outline"

import QRCode from "qrcode"
// import jsPDF from "jspdf"
import html2canvas from "html2canvas"
import { saveAs } from "file-saver"

import { mapGetters } from "vuex"

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    apptemp: {
      type: Object
    }
  },
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    XIcon
  },
  computed: {
    ...mapGetters(["getCurrentUser"])
  },
  data() {
    return {
      cc: false,
      email: "",
      subject: "",
      customMessage: "",
      showPhoneInput: false,
      phoneNumber: "",
      downloading: false
    }
  },
  watch: {
    showModal: {
      handler(val) {
        if (val) {
          this.$nextTick(() => this.generateQRCode())
        }
      }
    }
  },
  methods: {
    resetData() {
      Object.assign(this.$data, {
        cc: false,
        email: "",
        subject: "",
        customMessage: "",
        showPhoneInput: false,
        phoneNumber: ""
      })
    },
    closeModal() {
      this.resetData()
      this.$emit("close")
    },
    async generateQRCode() {
      const canvas = document.getElementById("qr-canvas")

      const url = `${this.baseHostName}/${this.apptemp.slug}?a=${btoa(
        this.getCurrentUser.username
      )}`

      await QRCode.toCanvas(canvas, url, { scale: 6 }, (error) => {
        if (error) {
          console.error(error)
        } else {
          const ctx = canvas.getContext("2d")
          const logoImage = new Image()
          logoImage.src =
            "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjUiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NSA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC4wMDM5MDYyNSIgeT0iMC4wMDA5NzY1NjIiIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgcng9IjMyIiBmaWxsPSIjMzY1OUMwIi8+CjxjaXJjbGUgY3g9IjMyLjAwMzkiIGN5PSIzMS45OTk2IiByPSIyOSIgZmlsbD0iIzMzMzMzMyIvPgo8cGF0aCBkPSJNMTUgMzIuMDAwMkgxNy42OEMxNy44NTY3IDMyLjAwMDIgMTggMzIuMTQzNSAxOCAzMi4zMjAyVjQzLjAwMDJINDZWMzIuMzIwMkM0NiAzMi4xNDM1IDQ2LjE0MzMgMzIuMDAwMiA0Ni4zMiAzMi4wMDAySDQ5QzQ5LjU1MjMgMzIuMDAwMiA1MCAzMS41NTI1IDUwIDMxLjAwMDJDNTAgMzAuNDQ3OSA0OS41NTIzIDMwLjAwMDIgNDkgMzAuMDAwMkg0OEw0NiAyOC41MDAyVjI0LjAwMDJDNDYgMjMuNDQ3OSA0NS41NTIzIDIzLjAwMDIgNDUgMjMuMDAwMkg0M0M0Mi40NDc3IDIzLjAwMDIgNDIgMjMuNDQ3OSA0MiAyNC4wMDAyVjI0Ljg1NzNMMzUuMTIzNSAxOC45NjMyQzM0LjM5ODUgMTguMzQxOCAzMy40NzUxIDE4LjAwMDIgMzIuNTIwMyAxOC4wMDAySDMxLjQ3OTdDMzAuNTI0OCAxOC4wMDAyIDI5LjYwMTUgMTguMzQxOCAyOC44NzY1IDE4Ljk2MzJMMTYgMzAuMDAwMkgxNUMxNC40NDc3IDMwLjAwMDIgMTQgMzAuNDQ3OSAxNCAzMS4wMDAyQzE0IDMxLjU1MjUgMTQuNDQ3NyAzMi4wMDAyIDE1IDMyLjAwMDJaIiBmaWxsPSJ3aGl0ZSIvPgo8bWFzayBpZD0ibWFzazAiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjMiIHk9IjIiIHdpZHRoPSI1OSIgaGVpZ2h0PSI1OSI+CjxjaXJjbGUgY3g9IjMyLjAwMzkiIGN5PSIzMS4wMDAzIiByPSIyOSIgZmlsbD0iI0M0QzRDNCIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazApIj4KPGNpcmNsZSBjeD0iMzIuMDAzOSIgY3k9Ijg5LjAwMDYiIHI9IjQ4IiBmaWxsPSIjMTZBMDg1IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9nPgo8Y2lyY2xlIGN4PSIzMi4wMDM5IiBjeT0iMzEuOTk5NiIgcj0iMjgiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8Y2lyY2xlIGN4PSIzMi4wMDM5IiBjeT0iMzEuOTk5NiIgcj0iMzAiIHN0cm9rZT0iIzM2NTlDMCIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxyZWN0IHg9IjI4LjAwMzkiIHk9IjMxLjAwMDYiIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHJ4PSIxIiBmaWxsPSIjMzMzMzMzIi8+CjxyZWN0IHg9IjI4LjAwMzkiIHk9IjM0LjAwMDciIHdpZHRoPSI4IiBoZWlnaHQ9IjIiIGZpbGw9IndoaXRlIi8+CjxyZWN0IHg9IjMxLjAwMzkiIHk9IjM5LjAwMDgiIHdpZHRoPSI4IiBoZWlnaHQ9IjIiIHRyYW5zZm9ybT0icm90YXRlKC05MCAzMS4wMDM5IDM5LjAwMDgpIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
          logoImage.width = 40
          logoImage.height = 40
          logoImage.onload = function () {
            ctx.drawImage(logoImage, canvas.width / 2.5, canvas.height / 2.5, 40, 40)
          }
        }
      })
    },
    downloadImage() {
      this.downloading = true
      const that = this

      const qrCanvas = document.getElementById("qr-canvas")

      html2canvas(qrCanvas, {
        useCORS: true,
        allowTaint: false,
        scale: 1,
        quality: 4,
        x: 0,
        y: 0,
        backgroundColor: "none"
      }).then((canvas) => {
        canvas.toBlob((blob) => {
          saveAs(blob, `form_${that.apptemp.slug}_qr.png`)
        })
        that.downloading = false
      })
    }
  }
}
</script>
<style scoped></style>
